// src/lib/react-query.ts
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (anciennement cacheTime)
      retry: 1,
      retryDelay: 1000,
      refetchOnWindowFocus: false, // Évite les rechargements inutiles
      refetchOnReconnect: false,
    },
  },
});